/*
 * Copyright (c) 2020-present Amida Technology Solutions, Inc.
 * All rights reserved.
 *
 * Licensed under the Amida proprietary license.
 * See LICENSE file in the project root for license information.
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ViewMode = 'manage' | 'learn';

interface ViewModeState {
  mode: ViewMode;
  setMode: (mode: ViewMode) => void;
  toggle: () => void;
}

export const useViewModeStore = create<ViewModeState>()(
  persist(
    (set, get) => ({
      mode: 'manage',
      setMode: (mode) => set({ mode }),
      toggle: () => set({ mode: get().mode === 'manage' ? 'learn' : 'manage' }),
    }),
    { name: 'lms-view-mode' }
  )
);
